import { FC, ReactElement } from 'react'
import Button from '../button'
import { Container } from './styles'

type PlanHorizontalProps = {
  name: string;
  items: string[];
  price: number;
  isActive?: boolean;
  to?: string;
}

const PlanHorizontal: FC<PlanHorizontalProps> = ({ isActive, name, price, items, to }): ReactElement => {
  const priceTwoParts = price.toFixed(2).split('.')

  return (
    <Container className='plan_horizontal'>
      <div className='plan_name'>{name}</div>
      <div className='plan_price_container'>
        <div className='plan_price'>
          R$ {priceTwoParts[0]},
          <span>{priceTwoParts[1]}</span>
        </div>
        <Button
          to={to}
          size='sm'
          variant={isActive ? 'muted' : 'primary'}
          block
        >
          {isActive ? 'Seu plano' : 'Trocar plano'}
        </Button>
      </div>
      <div className='plan_items'>
        {items.map(item => (<div key={`${item}-${name}`}>{item}</div>))}
      </div>
    </Container>
  )
}

export default PlanHorizontal
